import React, { useEffect, useRef } from 'react';
import Box from '@mui/material/Box';
import { drawLines } from '../../Jacques';
import { getChart } from '../../utils/charts';
import { showLegacyJacquesChart, showVisxJacquesChart } from '../../config';
import ReportJacquesChart from './ReportJacquesChart';

const CANVAS_WIDTH = 515;
const CANVAS_HEIGHT = 506;

export default function ReportChart({ language, companyChart, curva, age, ageAtReply }) {
    const canvasRef = useRef(null);

    useEffect(() => {
        if (!showLegacyJacquesChart || !canvasRef.current || curva === undefined || curva === null) return;
        let cancelled = false;
        const ctx = canvasRef.current.getContext('2d');
        ctx.clearRect(0, 0, CANVAS_WIDTH, CANVAS_HEIGHT);
        const img = new Image();
        img.src = getChart(language, companyChart, false);
        img.onload = () => {
            if (cancelled) return;
            ctx.drawImage(img, 0, 0);
            drawLines(ctx, curva, age);
        };
        return () => { cancelled = true; };
    }, [language, companyChart, curva, age]);

    return (
        <Box sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'flex-start',
            flexWrap: 'wrap',
            gap: 4,
            mt: 6,
            mb: 3,
        }}>
            {showLegacyJacquesChart && (
                <canvas ref={canvasRef} width={CANVAS_WIDTH} height={CANVAS_HEIGHT} />
            )}
            {showVisxJacquesChart && (
                <ReportJacquesChart
                    curva={curva}
                    age={age}
                    ageAtReply={ageAtReply}
                    companyChart={companyChart}
                    language={language}
                />
            )}
        </Box>
    );
}
